import { configureStore, combineReducers } from '@reduxjs/toolkit';
import rootReducer from './reducer';
import adminManagementReducer from './modules/adminManagement/reducer';
import communityReducer from './modules/community/reducer';
import curatedContentReducer from './modules/curatedContent/reducer';
import privacyPolicyReducer from './modules/privacyPolicy/reducer';
import termsAndConditionsReducer from './modules/termsAndConditions/reducer';
import communityTagReducer from './modules/communityTag/reducer';
import badgeReducer from './modules/badge/reducer';
import tagReducer from './modules/tag/reducer';

// Combine all reducers
const combinedReducer = combineReducers({
  root: rootReducer,
  adminManagement: adminManagementReducer,
  community: communityReducer,
  curatedContent: curatedContentReducer,
  privacyPolicy: privacyPolicyReducer,
  termsAndConditions: termsAndConditionsReducer,
  communityTag: communityTagReducer,
  badge: badgeReducer,
  tag: tagReducer,
});

const store = configureStore({
  reducer: combinedReducer,
  
  // preloadedState:getPreloadedState()
});
// function onStateChange() {
//   saveToLocalStorage(store.getState());
// }
// store.subscribe(onStateChange);
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;

export default store;
